<template>
  <div class="slider-container">
    <div class="slider">
      <div
        ref="fullTrack"
        class="slider-track"
        style="width: 100%;"
      />
      <div
        :style="`width: ${100 * (sliderModel - sliderMin) / (sliderMax - sliderMin)}%;
                 transition: ${this.mouseMoving ? '0ms' : '500ms'};`"
        class="slider-track slider-value"
      />
      <div
        :style="`left: ${100 * (sliderWarn - sliderMin) / (sliderMax - sliderMin)}%;
                 transition: ${this.mouseMoving ? '0ms' : '500ms'};
                  width: ${sliderModel > sliderWarn ? 100 * (sliderModel - sliderWarn) / (sliderMax - sliderMin) : 0}%;
                  opacity: ${sliderModel > sliderWarn ? 1 : 0}`"
        class="slider-track slider-warn"
      />
      <div
        :style="`position: absolute;
                 left: -${(100 / Math.floor((sliderMax-sliderMin)/sliderInterval)/2)}%;
                 width: calc(100% +  ${100 / Math.floor((sliderMax-sliderMin)/sliderInterval)}%)`"
      >
        <template v-for="(i, key) in Math.floor((sliderMax-sliderMin)/sliderInterval)+1">
          <template v-if="i === 1">
            <div
              :key="key"
              :style="`width: ${100 / (Math.floor((sliderMax-sliderMin)/sliderInterval)+1)}%`"
              class="slider-value-setter no-event"
            >
              <div
                class="slider-value-setter-inside"
                style="right: 0;"
                @click="setSliderValue(sliderMin)"
              />
            </div>
          </template>
          <template v-else-if="i === Math.floor((sliderMax-sliderMin)/sliderInterval)+1">
            <div
              :key="`second_${key}`"
              :style="`width: ${100 / (Math.floor((sliderMax-sliderMin)/sliderInterval)+1)}%`"
              class="slider-value-setter no-event"
            >
              <div
                class="slider-value-setter-inside"
                style="left: 0;"
                @click="setSliderValue(sliderMax)"
              />
            </div>
          </template>
          <template v-else>
            <div
              :key="`other_${key}`"
              :style="`width: ${100 / (Math.floor((sliderMax-sliderMin)/sliderInterval)+1)}%`"
              class="slider-value-setter"
              @click="setSliderValue(i*sliderInterval)"
            />
          </template>
        </template>
      </div>
      <div
        ref="seeker"
        :style="`left: calc(${100 * (sliderModel - sliderMin) / (sliderMax - sliderMin)}% - 50px);
                 background-color: ${sliderModel > sliderWarn ? 'var(--dark-yellow)' : 'var(--primary)'};
                 transition: ${this.mouseMoving ? '0ms' : '500ms'}`"
        class="slider-seeker"
        @mousedown="onMouseDown"
      >
        <span class="slider-value-on-seeker">
          {{ $t(label, {value: sliderModel}) }}
        </span>
      </div>
    </div>
    <span
      class="slider-adjust-value slider-minus"
      @click="sliderDown"
    >
      <i class="fa fa-minus" />
    </span>
    <span
      class="slider-adjust-value slider-plus"
      @click="sliderUp"
    >
      <i class="fa fa-plus" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    sliderMin: Number,
    // eslint-disable-next-line vue/require-default-prop
    sliderMax: Number,
    // eslint-disable-next-line vue/require-default-prop
    sliderInterval: Number,
    // eslint-disable-next-line vue/require-default-prop
    sliderWarn: Number,
    // eslint-disable-next-line vue/require-default-prop
    label: String,
    // eslint-disable-next-line vue/require-default-prop
    value: Number
  },
  data () {
    return {
      // sliderMin: 10,
      // sliderMax: 200,
      sliderModel: this.value,
      // sliderWarn: 100,
      // sliderInterval: 10,
      movement: 0,
      previousModel: this.sliderMin,
      mouseMoving: false,
      isWarning: this.value > this.sliderWarn
    }
  },
  watch: {
    sliderModel () {
      this.$emit('input', this.sliderModel)
      if (this.sliderModel > this.sliderWarn) {
        this.$emit('onWarn', true)
        this.isWarning = true
      } else {
        this.$emit('onWarn', false)
        this.isWarning = false
      }
    },
    value () {
      this.sliderModel = this.value
    }
  },
  methods: {
    sliderUp () {
      if (this.sliderModel + this.sliderInterval <= this.sliderMax) {
        this.sliderModel += this.sliderInterval
      }
    },
    sliderDown () {
      if (this.sliderModel - this.sliderInterval >= this.sliderMin) {
        this.sliderModel -= this.sliderInterval
      }
    },
    setSliderValue (value) {
      this.sliderModel = value
    },
    onMouseMove (data) {
      this.movement += data.movementX
      const fullTrack = this.$refs.fullTrack.offsetWidth
      const intervalSpace = fullTrack / (((this.sliderMax - this.sliderMin) / this.sliderInterval) + 1)
      const change = this.previousModel + Math.round(this.movement / intervalSpace) * this.sliderInterval
      if (change < this.sliderMin) {
        this.sliderModel = this.sliderMin
      } else if (change > this.sliderMax) {
        this.sliderModel = this.sliderMax
      } else {
        this.sliderModel = change
      }
    },
    onMouseDown () {
      window.addEventListener('mousemove', this.onMouseMove)
      window.addEventListener('mouseup', this.onMouseUp)
      this.previousModel = this.sliderModel
      this.mouseMoving = true
    },
    onMouseUp () {
      window.removeEventListener('mousemove', this.onMouseMove)
      window.removeEventListener('mousemove', this.onMouseUp)
      this.movement = 0
      this.mouseMoving = false
    },
    onTouchStart (event) {
      this.movement = event.changedTouches[0].clientX
      this.mouseMoving = true
      this.previousModel = this.sliderModel
    },
    onTouchMove (event) {
      const fullTrack = this.$refs.fullTrack.offsetWidth
      const intervalSpace = fullTrack / (((this.sliderMax - this.sliderMin) / this.sliderInterval) + 1)
      const change = this.previousModel + Math.round((event.changedTouches[0].clientX - this.movement) / intervalSpace) * this.sliderInterval
      if (change < this.sliderMin) {
        this.sliderModel = this.sliderMin
      } else if (change > this.sliderMax) {
        this.sliderModel = this.sliderMax
      } else {
        this.sliderModel = change
      }
    },
    onTouchEnd () {
      this.movement = 0
      this.mouseMoving = false
    }
  },
  mounted () {
    this.$emit('input', this.sliderModel)
    this.$refs.seeker.addEventListener('touchstart', this.onTouchStart)
    this.$refs.seeker.addEventListener('touchmove', this.onTouchMove)
    this.$refs.seeker.addEventListener('touchend', this.onTouchEnd)
  }
}
</script>

<style scoped>
.slider-container {
  position: relative;
  width: calc(100% - 100px);
  margin-left: 50px;
  height: 50px;
}

.slider-adjust-value {
  color: black;
  transition: 500ms;
  top: 5px;
  font-size: 1.5em;
  position: absolute;
}

.slider-adjust-value:hover {
  color: var(--primary);
}

.slider-minus {
  left: -50px;
}

.slider-plus {
  right: -40px;
}

.slider {
  position: relative;
}

.slider-minus:hover, .slider-plus:hover {
  cursor: pointer;
}

.slider-track {
  height: 4px;
  border-radius: 2px;
  background-color: #d0d9f0;
  position: absolute;
  top: 20px;
}

.slider-value {
  background-color: var(--primary);
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.slider-value:before {
  content: '';
  position: absolute;
  top: -18px;
  left: -20px;
  bottom: -18px;
  right: 0;
  background-color: var(--primary);
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
  opacity: 0.3;
}

.slider-warn {
  border-radius: 0;
  background-color: var(--secondary);
}

.slider-warn:before {
  content: '';
  position: absolute;
  top: -18px;
  left: 0;
  bottom: -18px;
  right: 0;
  background-color: var(--secondary);
  opacity: 0.3;
}

.slider-value-setter {
  position: relative;
  height: 40px;
  display: inline-block;
}

.slider-value-setter-inside {
  width: calc(50% + 20px);
  height: 100%;
  position: absolute;
}

.slider-seeker {
  z-index: 2;
  border-radius: var(--border-raduis) !important;
  width: 110px;
  text-align: center;
  padding: 8px 0;
  display: inline-block;
  position: absolute;
  top: 2px;
  color: white;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.slider-seeker:hover {
  cursor: pointer;
}

.slider-value-on-seeker::before {
  content: "▸";
  display: inline-block;
  -webkit-transform: rotate(-180deg);
  -ms-transform: rotate(-180deg);
  transform: rotate(-180deg);
  color: #ffffff66;
}

.slider-value-on-seeker::after {
  content: "▸";
  display: inline-block;
  color: #ffffff66;
}

.no-event {
  height: 0;
  position: relative;
}

.no-event > div {
  height: 40px;
  bottom: 0;
  position: absolute;
}

@media screen and (max-width: 767px) {
  .slider-value-on-seeker {
    font-size: 0.8em;
  }
}
</style>
